export const MatchString = (tags: string[], newTag: string): boolean => {
  return !tags.some(tag => tag.toLowerCase() === newTag.toLowerCase())
}
